// extracted by mini-css-extract-plugin
export default {"QuizFinished":"quizFinished_QuizFinished__4hFwf"};